import { LabelTheme } from '@kite-js/theme-types';

const label: LabelTheme = {
    textWeight: 'Strong',
};

export default label;
